import { useQueryGrid } from '@gogame/query';

import { loadTable } from '../sources/creativesTracker';

import { grid } from './queryKeyFactory';

export const useLoadCreativesTracker = (params, ready) => {
  return useQueryGrid(
    grid({ ...params }),
    (_, { signal }) => loadTable(params, { signal }),
    { enabled: ready, staleTime: 50 * 1000 }
  );
};
